/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import store from '@/store/index'
import { Loading, Message } from 'element-ui';
import router from '@/router'
var that=this
const loading={ //loading加载对象
  loadingInstance: null,
  //打开加载
  open(){
    if(this.loadingInstance===null){ // 如果实例 为空，则创建
      this.loadingInstance=Loading.service({
        text:'加载中...', //加载图标下的文字
        spinner: 'el-icon-loading', //加载图标
        background:'rgba(0, 0, 0, 0.8)', //背景色
        customClass:'loading' //自定义样式的类名
      })
    }
  },
  //关闭加载
  close(){
    // 不为空时, 则关闭加载窗口
    if(this.loadingInstance !== null) {
      this.loadingInstance.close()
    }
    this.loadingInstance = null
  }
}

axios.defaults.baseURL = 'https://dogs.zhuanqianpa.cn/dogs_dev';
// axios.defaults.baseURL = 'http://dogs.free.idcfengye.com/merchant';
// // 环境的切换
// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = 'http://101.200.81.105:8097/';
// } else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = 'http://101.200.81.105:8097/';
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'http://101.200.81.105:8097/';
// }

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['logType'] = 0;
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    return config;
  },
  error => {
    return Promise.error(error);
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {


    if (response.data.code == 2000) {
      return Promise.resolve(response);
    } else if(response.data.code == 9006){
      // alert('登录过期，请重新登录')
      Message.error('登录过期，请重新登录')
      // 清除token

      localStorage.removeItem('token');
      // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      setTimeout(() => {
        router.replace({
          path: '/login',

        });
      }, 1000);
    } else{
      console.log( response.data.msg)
      Message.error(response.data.msg)
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error)
    if (error.code) {
      // console.log(error.response.status)
      switch (error.code) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/index',
            query: {
              redirect: router.currentRoute.fullPath,
              FooterI:3
            }
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 9006:
          this.$message({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token
          localStorage.removeItem('token');
          store.commit('loginSuccess', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath,
                FooterI:3
              }
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          this.$message({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          this.$message({
            message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          });
      }
      return Promise.reject(error.response);
    }
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){

  return new Promise((resolve, reject) =>{

    axios.get(url, {
      params: params
    })
      .then(res => {

        if (res.data.code==9006){
          localStorage.clear()
          Message.error('登录过期，请重新登录')

          router.push('/login')
        } else{
          resolve(res.data);
        }
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {

    axios.post(url,params)
      .then(res => {
        if (res.data.code==9001){
          console.log(res.data.code)
          localStorage.clear()
          Message.error('登录过期，请重新登录')

          router.push('/login')

        } else{
          resolve(res.data);
        }

      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js